export const userColors = [
  "#881798",
  "#13316D",
  "#00B0F0",
  "#17864C",
  "#FFA800",
  "#F67517",
  "#C00000",
  "#E3008C",
];
